// src/components/SurahAyahSelector.js
import React from 'react';
import {
  FormControl, FormLabel, FormHelperText, Select, SimpleGrid,
  NumberInput, NumberInputField,
} from '@chakra-ui/react';
import { surahList, getSurah } from '../data/surahMeta';

/**
 * Optional Surah + ayah range picker.
 * value: { surahId, ayahStart, ayahEnd } (strings, '' when unset)
 */
const SurahAyahSelector = ({ value, onChange, label = 'Quran reference (optional)' }) => {
  const surah = getSurah(value.surahId);

  const update = (changes) => onChange({ ...value, ...changes });

  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3}>
        <Select
          placeholder="Whole Quran / not specific"
          value={value.surahId}
          onChange={(e) => update({ surahId: e.target.value, ayahStart: '', ayahEnd: '' })}
        >
          {surahList.map((s) => (
            <option key={s.id} value={s.id}>
              {s.id}. {s.name} ({s.arabicName})
            </option>
          ))}
        </Select>
        <NumberInput
          min={1}
          max={surah?.ayahCount}
          value={value.ayahStart}
          isDisabled={!surah}
          onChange={(v) => update({ ayahStart: v })}
        >
          <NumberInputField placeholder="From ayah" />
        </NumberInput>
        <NumberInput
          min={1}
          max={surah?.ayahCount}
          value={value.ayahEnd}
          isDisabled={!surah || !value.ayahStart}
          onChange={(v) => update({ ayahEnd: v })}
        >
          <NumberInputField placeholder="To ayah" />
        </NumberInput>
      </SimpleGrid>
      <FormHelperText>
        {surah
          ? `${surah.name} has ${surah.ayahCount} ayahs. Leave the ayahs empty to refer to the whole surah.`
          : 'Pick a surah if the material is about a specific part of the Quran.'}
      </FormHelperText>
    </FormControl>
  );
};

export default SurahAyahSelector;
